import React, {useState} from 'react';
import Popup, {Position} from "./popup";
import ColorPickerPopup from './color-picker-popup';
import {useTrans} from '../../redux/storages/i18n-storage';
import * as cnfStorage from '../../redux/storages/configuration-storage'
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {IModelConfiguration} from "../../model.schema";

interface IProps {
    configuration: IModelConfiguration,
    onClose: () => void,
}

const ColorPickerPopupContainer: React.FC<IProps> = ({configuration, onClose}) => {
    const dispatch = useAppDispatch();
    const t = useTrans();
    let colorValue = useAppSelector(cnfStorage.selectors.getCurrentColorValue);
    if(undefined === colorValue) {
        colorValue = '#fff';
    }
    const name = configuration.material.name;
    const [initialValue] = useState<string>(colorValue);

    const closeHandler = () => {
        dispatch(cnfStorage.actions.setColor(name, initialValue));
        onClose();
    }

    const changeHandler = (value: string) => {
        dispatch(cnfStorage.actions.setColor(name, value));
    }

    return (
        <Popup
            position={Position.right}
            onSubmit={onClose}
            onClose={closeHandler}
            fullHeight={false}
        >
            <ColorPickerPopup
                t={t}
                color={colorValue}
                onChange={changeHandler}
            />
        </Popup>
    );
}

export default ColorPickerPopupContainer